import React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Courses.css";

import CI1 from "../assets/CI1.jpeg";
import CI2 from "../assets/CI2.jpeg";
import CI3 from "../assets/CI3.jpeg";

function Courses() {
  const navigate = useNavigate();

  const categories = [
    {
      id: "technical",
      title: "Software Courses",
      text: "Explore programming, cloud, AI, data science, and more.",
      img: CI1,
    },
    {
      id: "management",
      title: "Management Courses",
      text: "Business, analytics, and marketing courses to upskill your career.",
      img: CI2,
    },
    {
      id: "tp",
      title: "Training & Placement",
      text: "Job-oriented training, aptitude & interview preparation.",
      img: CI3,
    },
  ];

  const handleCategoryClick = (categoryId) => {
  if (categoryId === "tp") {
    navigate("/course/trainingandplacement"); // open page directly
  } else {
    navigate(`/courses/${categoryId}`);
  }
};


  return (
    <div className="courses-section py-5">
      <Container>
        <h1 className="courses-title text-center mb-3">Our Courses</h1>
        <p className="courses-subtitle text-center mb-5">
          Choose a category to explore the courses we offer.
        </p>

        <Row>
          {categories.map((cat) => (
            <Col md={4} sm={6} xs={12} key={cat.id} className="mb-4">
              <Card
                className="course-card shadow-sm border-0 h-100"
                onClick={() => handleCategoryClick(cat.id)}
                style={{ cursor: "pointer" }}
              >
                <Card.Img variant="top" src={cat.img} className="course-img" />
                <Card.Body>
                  <Card.Title>{cat.title}</Card.Title>
                  <Card.Text>{cat.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Courses;
